//@ts-check
import { Grid } from '@material-ui/core'
import React from 'react'

/**
 * @typedef {Object} InteractiveItemProps
 * @property {React.ReactNode} children - The child elements to be rendered inside the InteractiveItem.
 */

/**
 * @param {import('@material-ui/core').GridProps & InteractiveItemProps} props
 */

const InteractiveContainer = ({ children, ...props }) => {
    return (
        <Grid container spacing={2} {...props}>
            {children}
        </Grid>
    )
}

export default InteractiveContainer